import { useEasasJsVersions } from "api/api-hooks/easasjs-version-hooks";
import { MetaOptions } from "api/model/dashboard/DashboardReportOptions";
import React, { useMemo } from "react";
import { Leaves, setObjAttribute } from "utils/utils";
import { Input } from "../InputCategories";


type MetaOptionsKey = Leaves<MetaOptions>;
export const MetaOptionsSubForm = (props: {
    metaOptions?: MetaOptions;
    onChange: (o?: MetaOptions) => void;
  }) => {
    const { data, isLoading, error } = useEasasJsVersions();
  
    const buildOptions = useMemo(() => {
      if (!data) return [];
  
      type BuildType = "v" | "b" | "dev" | "hotfix" | "rolling";
      const bucketMapper = (key: BuildType) => {
        switch (key) {
          case "v":
            return "Old builds";
          case "b":
            return "Builds";
          case "dev":
            return "Development";
          case "hotfix":
            return "Hotfix/Patch";
          case "rolling":
            return "Rolling builds";
        }
      };
      const buildsMap: Record<
        BuildType,
        Array<{ label: string; value: string }>
      > = {
        v: [],
        b: [],
        dev: [],
        hotfix: [],
        rolling: [],
      };
  
      data.builds.map((b) => {
        if (b.endsWith("-hotfix")) {
          buildsMap["hotfix"].push({ label: b, value: b });
        } else if (b.endsWith("-dev")) {
          buildsMap["dev"].push({ label: b, value: b });
        } else if (b.startsWith("v")) {
          buildsMap["v"].push({ label: b, value: b });
        } else if (b.startsWith("b")) {
          buildsMap["b"].push({ label: b, value: b });
        } else {
          buildsMap["rolling"].push({ label: b, value: b });
        }
      });
  
      return (["rolling", "hotfix", "dev", "b", "v"] as Array<BuildType>).map(
        (k) => {
          const sortedItems = buildsMap[k as BuildType].sort((a, b) =>
            b.label.localeCompare(a.label)
          );
          return {
            label: bucketMapper(k as BuildType),
            code: k,
            items: sortedItems,
          };
        }
      );
    }, [data]);
  
    const onChangeMetaOptions = (prop: MetaOptionsKey, value: any) => {
      const newMetaOptions = { ...props.metaOptions };
      setObjAttribute(newMetaOptions, prop, value);
      props.onChange(newMetaOptions);
    };
  
    return (
      <React.Fragment>
        <h5 className="mb-5">Other Options</h5>
        <div className="grid">
          <span className="p-float-label col-12 md:col-4 mb-4">
            <Input.List
              id="meta-jsbuild-for-gen"
              label="JS Build tag for generation"
              property={"jsBuild"}
              sourceObj={props.metaOptions}
              onChange={onChangeMetaOptions}
              options={buildOptions}
              filter={true}
              grouped={true}
              editable={true}
            />
          </span>
        </div>
      </React.Fragment>
    );
  };
  